import { variant } from "valibot"
import { GamepadInputBindingSchema, type GamepadInputBinding } from "./GamepadInputBinding.type"
import { KeyboardInputBindingSchema, type KeyboardInputBinding } from "./KeyboardInputBinding.type"
import { MouseClickInputBindingSchema, type MouseClickInputBinding } from "./MouseClickInputBinding.type"
import { TouchClickInputBindingSchema, type TouchClickInputBinding } from "./TouchClickInputBinding.type"

export type AnyInputBinding = KeyboardInputBinding | MouseClickInputBinding | TouchClickInputBinding | GamepadInputBinding

export const AnyInputBindingSchema = variant('device', [
  KeyboardInputBindingSchema,
  MouseClickInputBindingSchema,
  TouchClickInputBindingSchema,
  GamepadInputBindingSchema,
])
